(() => {
  const initStickyCartBar = (elementWrapper) => {
    const SEL = window.ProductVariantSelectors;
    const originalButton = document.querySelector(SEL.addToCartButton);
    const stickyBar = document.querySelector(".sticky-cart-bar");
    const stickyContainer = document.querySelector(".sticky-cart-bar__container");
    const stickyRight = document.querySelector(".sticky-cart-bar__right");
    const footer = document.querySelector("#main-footer");

    if (!originalButton || !stickyBar || !stickyContainer || !stickyRight) {
      console.warn(
        `sticky bar not being initialised because: ${!originalButton}, ${!stickyBar}, ${!stickyContainer}, ${!stickyRight}`,
      );
      return;
    }

    const clonedButton = originalButton.cloneNode(true);
    stickyRight.appendChild(clonedButton);

    const copyButtonStyle = () => {
      const originalStyle = originalButton.getAttribute("style");
      if (originalStyle) {
        window.setAttributeIfDifferent(clonedButton, "style", originalStyle);
      }
    };

    const isNotifyMeVisible = () => {
      const originalNotifyButton = elementWrapper.querySelector(SEL.notifyMeButton);
      return originalNotifyButton && originalNotifyButton.style.display !== "none";
    };

    const isKlaviyoVisible = () => {
      const klaviyoForm = elementWrapper.querySelector(SEL.klaviyoForm);
      return (
        klaviyoForm &&
        klaviyoForm.style.display !== "none" &&
        klaviyoForm.style.display !== ""
      );
    };

    const isNotifyMeState = () => isNotifyMeVisible() || isKlaviyoVisible();

    const isVariantIncomplete = () => !product_has_only_default_variant && originalButton.disabled;

    const currentPriceText = () => {
      const variant = window.ProductVariantState.getVariant();
      if (variant) return window.formatVariantPrice(variant).actual;
      const priceEl = document.querySelector(".js--sticky-price");
      return priceEl ? priceEl.textContent.trim() : "";
    };

    const mobilePriceSuffix = () => {
      if (window.innerWidth > 768) return "";
      const price = currentPriceText();
      return price ? ` • ${price}` : "";
    };

    const isAdding = () => originalButton.querySelector(".loader--spinner") !== null;

    let restingButtonText = originalButton.textContent.trim();

    const screenReaderLabel = () =>
      Object.assign(document.createElement("span"), {
        className: "visually-hidden",
        textContent: `${restingButtonText}${mobilePriceSuffix()}`,
      });

    const syncButtons = () => {
      clonedButton.disabled = false;
      window.setIfDifferent(clonedButton, "className", originalButton.className);
      copyButtonStyle();

      if (isAdding()) {
        clonedButton.replaceChildren(...originalButton.cloneNode(true).childNodes, screenReaderLabel());
      } else if (isNotifyMeState()) {
        window.setTextIfDifferent(clonedButton, "Notify Me");
        clonedButton.style.display = "flex";
      } else {
        window.setTextIfDifferent(clonedButton, `${originalButton.textContent.trim()}${mobilePriceSuffix()}`);
        window.setIfDifferent(clonedButton, "type", originalButton.type);
        window.setIfDifferent(clonedButton, "name", originalButton.name);
        window.setIfDifferent(clonedButton, "value", originalButton.value);
      }
    };

    const syncAll = () => {
      updateStickyPrices();
      syncButtons();
      updateSelectedInfo();
    };

    const isShown = () => stickyBar.classList.contains("is-visible");

    const syncAllWhileShown = () => {
      if (isShown()) syncAll();
    };

    const syncButtonsWhileShown = () => {
      if (isShown()) syncButtons();
    };

    clonedButton.addEventListener("click", (e) => {
      e.preventDefault();

      if (isNotifyMeState()) {
        scrollToVariantForm();
        if (isNotifyMeVisible()) {
          const originalNotifyButton = elementWrapper.querySelector(SEL.notifyMeButton);
          setTimeout(() => originalNotifyButton.click(), 300);
        }
      } else if (isVariantIncomplete()) {
        scrollToVariantForm();
      } else {
        originalButton.click();
      }
    });

    const activeCartControlRect = () => {
      const addToCartButton = elementWrapper.querySelector(SEL.addToCartButton);

      if (isKlaviyoVisible()) {
        return elementWrapper.querySelector(SEL.klaviyoForm).getBoundingClientRect();
      }
      if (isNotifyMeVisible()) {
        return elementWrapper.querySelector(SEL.notifyMeButton).getBoundingClientRect();
      }
      if (addToCartButton && addToCartButton.style.display !== "none") {
        return addToCartButton.getBoundingClientRect();
      }
      return originalButton.getBoundingClientRect();
    };

    const hubLauncherHome = { parent: null, nextSibling: null, styleCssText: "" };

    const dockedStyleProps = { position: "static", inset: "auto", margin: "0" };

    const applyDockedStyle = (hubLauncher) => {
      Object.entries(dockedStyleProps).forEach(([prop, value]) => {
        hubLauncher.style.setProperty(prop, value, "important");
      });
    };

    const hubLauncherObserver = new MutationObserver((mutations) => {
      const hubLauncher = mutations[0].target;
      if (hubLauncher.dataset.stickyDocked === "true") applyDockedStyle(hubLauncher);
    });

    const dockHubLauncher = (hubLauncher) => {
      if (hubLauncher.dataset.stickyDocked !== "true") {
        hubLauncherHome.parent = hubLauncher.parentElement;
        hubLauncherHome.nextSibling = hubLauncher.nextElementSibling;
        hubLauncherHome.styleCssText = hubLauncher.style.cssText;
        hubLauncher.dataset.stickyDocked = "true";
        stickyRight.appendChild(hubLauncher);
        hubLauncherObserver.observe(hubLauncher, { attributes: true, attributeFilter: ["style"] });
      }
      applyDockedStyle(hubLauncher);
    };

    const undockHubLauncher = (hubLauncher) => {
      if (hubLauncher.dataset.stickyDocked !== "true") return;

      hubLauncherObserver.disconnect();
      hubLauncher.dataset.stickyDocked = "false";
      hubLauncher.style.cssText = hubLauncherHome.styleCssText;
      if (hubLauncherHome.parent) {
        hubLauncherHome.parent.insertBefore(hubLauncher, hubLauncherHome.nextSibling);
      }
    };

    const canTakeFocus = (control) => control && !control.disabled && control.getClientRects().length > 0;

    const chosenOrFirstSize = () =>
      elementWrapper.querySelector(`${SEL.variantOption}:checked`) ?? elementWrapper.querySelector(`${SEL.variantOption}:not(:disabled)`);

    const focusMainControl = () => {
      const control = [originalButton, elementWrapper.querySelector(SEL.notifyMeButton), chosenOrFirstSize()].find(canTakeFocus);
      control?.focus({ preventScroll: true });
    };

    const checkButtonPosition = () => {
      const footerInView = footer && footer.getBoundingClientRect().top < window.innerHeight;
      const shouldShow = activeCartControlRect().bottom < 0 && !footerInView;
      const dropsFocus = !shouldShow && !footerInView && stickyBar.contains(document.activeElement);
      if (shouldShow && !isShown()) syncAll();
      stickyBar.classList.toggle("is-visible", shouldShow);
      if (dropsFocus) focusMainControl();

      const hubLauncher = document.querySelector(".kl-hub-launcher-container");
      if (hubLauncher) {
        shouldShow ? dockHubLauncher(hubLauncher) : undockHubLauncher(hubLauncher);
      }
    };

    window.ProductVariantState.onVariantChange(syncAllWhileShown);

    const followOriginalButton = () => {
      if (!isAdding()) restingButtonText = originalButton.textContent.trim();
      syncButtonsWhileShown();
    };

    new MutationObserver(followOriginalButton).observe(originalButton, { childList: true });

    window.addEventListener("scroll", checkButtonPosition);

    window.addEventListener("resize", () => {
      syncAllWhileShown();
      checkButtonPosition();
    });

    checkButtonPosition();
    syncAll();
  };

  const updateStickyPrices = () => {
    const variant = window.ProductVariantState.getVariant();
    if (!variant) return;

    const price = window.formatVariantPrice(variant);

    const priceEl = document.querySelector(".js--sticky-price");
    if (priceEl) window.setTextIfDifferent(priceEl, price.actual);

    const compareEl = document.querySelector(".js--sticky-compare-price");
    if (compareEl) window.showComparePrice(compareEl, price.compare);
  };

  const updateSelectedInfo = () => {
    const selectedEl = document.querySelector(".js--sticky-selected");
    if (!selectedEl) return;

    const variant = window.ProductVariantState.getVariant();
    const values = variant
      ? [variant.option1, variant.option2, variant.option3].filter(
          (value) => value && value !== "Default Title",
        )
      : [];

    if (values.length === 0) {
      window.setIfDifferent(selectedEl, "hidden", true);
      return;
    }

    window.setTextIfDifferent(selectedEl, `Selected Size: ${values.join(" ")}`);
    window.setIfDifferent(selectedEl, "hidden", false);
  };

  const scrollToVariantForm = () => {
    const productDetails = document.querySelector("#product-details");
    const fixedHeader = document.querySelector(".header-fixed");

    if (productDetails) {
      const rect = productDetails.getBoundingClientRect();
      const headerHeight = fixedHeader ? fixedHeader.offsetHeight : 0;
      const targetPosition = window.pageYOffset + rect.top - headerHeight + 1;

      window.scrollTo({
        top: targetPosition,
        behavior: "smooth",
      });
    }
  };

  document.addEventListener("DOMContentLoaded", () => {
    const productElement = document.querySelector("#product");
    if (productElement) {
      initStickyCartBar(productElement);
    }
  });
})();
